export default __webpack_public_path__ + "static/media/checkmark.6d84bc1c.svg";